"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteOptions = exports.CoreOptions = void 0;
exports.CoreOptions = {
    type: {
        required: true,
        type: String,
        hint: 'type of autocomplete',
        configurableInWebapp: true,
        defaultValue: 'what',
    },
    country: {
        required: true,
        type: String,
        hint: 'country of autocomplete',
        configurableInWebapp: true,
        defaultValue: 'US',
    },
    language: {
        required: true,
        type: String,
        hint: 'language of autocomplete',
        configurableInWebapp: true,
        defaultValue: 'en',
    },
    count: {
        required: true,
        type: Number,
        hint: 'max number of suggestion shown, "-1" to no limit',
        notForTypes: ['combined'],
        configurableInWebapp: true,
        defaultValue: 5,
    },
    types: {
        required: true,
        type: [String],
        hint: 'types for combined autocomplete',
        onlyForTypes: ['combined'],
        configurableInWebapp: true,
        defaultValue: ['what'],
    },
    counts: {
        required: true,
        type: [Number],
        hint: 'counts for combined autocomplete - same as number of types. Will only use first count if merged is true',
        onlyForTypes: ['combined'],
        configurableInWebapp: true,
        defaultValue: [5],
    },
    enableEmptyQuery: {
        type: Boolean,
        hint: 'suggestions on empty',
        configurableInWebapp: true,
        defaultValue: true,
    },
    page: {
        required: true,
        type: String,
        hint: 'page id used for collecting data, e.g. "mobile"',
        configurableInWebapp: true,
        defaultValue: 'XXX',
    },
    useEachWord: {
        type: Boolean,
        hint: 'enable each word search, see document',
        configurableInWebapp: true,
        defaultValue: true,
    },
    showAlternateSuggestions: {
        type: Boolean,
        hint: 'show alternate suggestions of taxonomy dictionaries',
        configurableInWebapp: true,
        defaultValue: false,
    },
    merged: {
        type: Boolean,
        hint: 'intermix results from different autocomplete types',
        onlyForTypes: ['combined'],
        configurableInWebapp: true,
        defaultValue: false,
    },
    grouped: {
        type: Boolean,
        hint: 'expand sub-selections into their own selectable suggestions',
        onlyForTypes: ['combined', 'job-title-with-occupations'],
        configurableInWebapp: true,
        defaultValue: false,
    },
    recentQueryCount: {
        type: Number,
        hint: 'max number of recent suggestion',
        configurableInWebapp: true,
        defaultValue: 2,
    },
    recentQuery: {
        type: [String],
        hint: 'recent searched strings, e.g. ["software engineer"]',
        configurableInWebapp: true,
        defaultValue: [],
    },
    dedupeRecentQueryResultsCaseInsensitively: {
        type: Boolean,
        hint: 'When autocomplete core removes duplicated results, use case insensitive match.',
        configurableInWebapp: true,
        defaultValue: false,
    },
    userIdentifiers: {
        required: true,
        type: Object,
        hint: 'user ID, e.g. { "ctk": "xxxxxxxx" }',
        defaultValue: {},
    },
    loggingListeners: {
        type: [Function],
        hint: 'event listener called when logging happens',
        defaultValue: [],
    },
    useCurrentLocation: {
        type: Boolean,
        hint: 'Use current location in where autocomplete.',
        defaultValue: false,
        configurableInWebapp: true,
        onlyForTypes: ['location'],
    },
    submitOnSelected: {
        type: Boolean,
        hint: 'Submit on selection, if the app submits form on every selection, this should be checked.',
        defaultValue: false,
        configurableInWebapp: true,
    },
    pageSessionId: {
        required: false,
        type: String,
        hint: 'pageSessionId is a unique identifier used for grouping multiple autocompletes in one page',
        configurableInWebapp: true,
        defaultValue: '',
    },
    debounce: {
        type: Boolean,
        hint: 'When set to true, it will wait for debounceTimeoutInMs milliseconds before firing a request to Autocomplete backend, default true for street-location',
        defaultValue: false,
        configurableInWebapp: false,
    },
    debounceTimeoutInMs: {
        type: Number,
        hint: 'The value in milliseconds before firing a request to Autocomplete backend when debounce option is set to true. Defaults to 200ms',
        defaultValue: 200,
        configurableInWebapp: true,
        eval: function (value) {
            if (value <= 0) {
                return {
                    valid: false,
                    errorMsg: 'debounceTimeoutInMs must be a positive numeric value.',
                };
            }
            return {
                valid: true,
            };
        },
    },
    minimumQueryLength: {
        type: Number,
        hint: 'The minimum length of query to send request to autocomplete service. Default is 0, means no minimum length requirement.',
        defaultValue: 0,
        configurableInWebapp: true,
        eval: function (value) {
            if (value < 0) {
                return {
                    valid: false,
                    errorMsg: 'minimumQueryLength must be a non-negative numeric value.',
                };
            }
            return {
                valid: true,
            };
        },
    },
    searchOnAddressNumber: {
        type: String,
        hint: 'Specifies if Address Number matching the input number are returned or not. Input Y or N.',
        defaultValue: 'Y',
        onlyForTypes: ['street-location'],
        configurableInWebapp: true,
    },
    includeRangesDetails: {
        type: String,
        hint: 'Specifies whether to return ranges and units information in the response. When this parameter is set to Y, it will return place name and unit details in response.',
        defaultValue: 'N',
        onlyForTypes: ['street-location'],
        configurableInWebapp: true,
    },
    ipAddress: {
        type: String,
        hint: 'Specifies the ip address to be used to detect the location to perform the address search around that location.',
        defaultValue: '',
        onlyForTypes: ['street-location'],
        configurableInWebapp: true,
    },
    rich: {
        type: Boolean,
        hint: 'Specifies whether to return rich response such as query matching scores',
        defaultValue: true,
        configurableInWebapp: true,
    },
    locationTypes: {
        type: Array,
        hint: 'Specifies location type filter such as COUNTRY, CITY and STATION. Refer to LocationTypes enum class.',
        defaultValue: null,
        onlyForTypes: ['where'],
    },
    endpoint: {
        type: String,
        hint: 'Provide a different service address for autocomplete. You can provide endpoint=AutocompleteCore.QA for qa',
        defaultValue: '',
    },
    prefLabelDenyList: {
        type: Array,
        hint: 'SUIDs/UUIDs for taxonomy autocomplete where we do not want to show pref labels',
        defaultValue: null,
    },
    prforceGroups: {
        type: Array,
        hint: 'Provide proctor force groups for testing',
        defaultValue: null,
    },
    stealthGroups: {
        type: Array,
        hint: 'Stealth group strings. The user is forced to be into specific Proctor groups for user testing.',
        defaultValue: null,
    },
    useUserOccupation: {
        type: Boolean,
        hint: 'Specifies whether to use personalized what or not. Currently deprecated as test is suspended',
        defaultValue: true,
        onlyForTypes: ['what', 'combined'],
    },
    prioritizeExactMatch: {
        type: Boolean,
        hint: 'Prioritize exact match',
        configurableInWebapp: true,
        defaultValue: false,
    },
    titleNorm: {
        type: Boolean,
        hint: 'Specifies if IN market specific job-job-title autocomplete should be used',
        defaultValue: false,
        onlyForTypes: ['job-job-title'],
        configurableInWebapp: true,
    },
    titleNormThreshold: {
        type: Number,
        hint: 'If IN market specific changes are active, normalize the query using TitleNorm if numebr of suggestions are less than this number',
        defaultValue: 0,
        onlyForTypes: ['job-job-title'],
        configurableInWebapp: true,
    },
    where: {
        type: String,
        hint: 'This should be the location from the Where-box on SERP or Homepage. This is used for location-aware What-box autocomplete.',
        defaultValue: '',
        configurableInWebapp: true,
        onlyForTypes: [
            'cmp-what',
            'cmp-what-with-top-companies',
            'combined',
            'what',
            'what-location-aware',
        ],
    },
};
var UIOptions = {
    suggestOnFocus: {
        type: Boolean,
        hint: 'Show suggestions when focus.',
        configurableInWebapp: true,
        defaultValue: true,
    },
    suggestOnInputBoxClick: {
        type: Boolean,
        hint: 'Show suggestions when click input box',
        configurableInWebapp: true,
        defaultValue: false,
    },
    classPrefix: {
        type: String,
        hint: 'CSS class prefix, see CSS Style tab',
        configurableInWebapp: true,
        defaultValue: 'icl',
    },
    parentSelectable: {
        type: Boolean,
        hint: 'Parent label selectable in UI.',
        onlyForTypes: ['job-title-with-occupations'],
        configurableInWebapp: true,
        defaultValue: false,
    },
    scrollable: {
        type: Boolean,
        hint: "Show scroll when suggestions' height exceeds option `maxHeight`.",
        configurableInWebapp: true,
        defaultValue: false,
    },
    maxHeight: {
        type: String,
        hint: 'Max height used when scrollable is true.',
        configurableInWebapp: true,
        defaultValue: '5em',
    },
    showTabs: {
        type: Boolean,
        hint: 'Show tabs in tabbed autocomplete UI.',
        onlyForTypes: ['combined'],
        defaultValue: true,
    },
    tabContainer: {
        type: String,
        hint: 'HTML element for tabs, typically a <div>.',
        onlyForTypes: ['combined'],
        defaultValue: '',
    },
    tabSelectListeners: {
        type: [Function],
        hint: 'Event listener when tab is selected.',
        onlyForTypes: ['combined'],
        defaultValue: [],
    },
    tabTitles: {
        type: Object,
        hint: 'Tab title mapper, e.g. { "what": "ALL" }.',
        onlyForTypes: ['combined'],
        defaultValue: {},
    },
    icon: {
        eval: function (value) {
            if (typeof value !== 'string' && typeof value !== 'function') {
                return {
                    valid: false,
                    errorMsg: 'icon must be a built in icon name or a function that returns an url',
                };
            }
            return {
                valid: true,
            };
        },
        hint: 'An name of a built in icon, or a function that takes an AutocompleteItem and return a string.' +
            'The string should be the url of the custom icon',
        configurableInWebapp: true,
        defaultValue: '',
    },
    disableMatchHighlight: {
        type: Boolean,
        hint: 'Disable match highlight.',
        configurableInWebapp: true,
        defaultValue: false,
    },
    suggestionsChangeListeners: {
        type: [Function],
        hint: 'Event listeners called when suggeations changed.',
        defaultValue: [],
    },
    valueChangeListeners: {
        type: [Function],
        hint: 'Event listeners called when value changed.',
        defaultValue: [],
    },
    hoverListeners: {
        type: [Function],
        hint: 'Event listeners called when suggestion hovered.',
        defaultValue: [],
    },
    selectListeners: {
        type: [Function],
        hint: 'Event listeners called when suggestion selected.',
        defaultValue: [],
    },
    disableDefaultStyle: {
        type: Boolean,
        hint: 'Disable default CSS styling.',
        defaultValue: false,
    },
    forceIgnoreBlur: {
        type: Boolean,
        hint: 'force ignore blur in UI input element',
        configurableInWebapp: true,
        defaultValue: false,
    },
    selectLimited: {
        type: Boolean,
        hint: 'When this flag is true, the value of text input can only be updated by selections of suggestions. Characters typed manually will be cleaned up after blur.',
        configurableInWebapp: true,
        defaultValue: false,
    },
    resultsAvailableAriaCallback: {
        type: Function,
        hint: 'Result callback for accessibility.',
        defaultValue: function () { },
    },
    onSingleTypeSuggestionLoaded: {
        type: Function,
        hint: 'hook called when single type suggestions is loaded, implementation need to return modified suggestions',
        defaultValue: function (suggestions) { return suggestions; },
    },
    onCombinedSuggestionsLoaded: {
        type: Function,
        hint: 'hook called when combined suggestions is loaded, implementation need to return modified combined suggestion',
        defaultValue: function (combinedSuggestions) { return combinedSuggestions; },
    },
};
var AutocompleteOptions = __assign(__assign({}, exports.CoreOptions), Object.entries(UIOptions)
    .map(function (_a) {
    var k = _a[0], v = _a[1];
    return [k, __assign(__assign({}, v), { section: 'ui' })];
})
    .reduce(function (r, _a) {
    var _b;
    var k = _a[0], v = _a[1];
    return (__assign(__assign({}, r), (_b = {}, _b[k] = v, _b)));
}, {}));
exports.AutocompleteOptions = AutocompleteOptions;
//# sourceMappingURL=data:application/json;base64,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